// external scripts
import debug from 'bows';

import { emptyLinks } from './_links';
import Clipboard from './_clipboard';
import Filters from './_filters';
import fitvid from './_fitvid';
import mediaQueries from './_media-queries';
import MobileHeader from './_mobile-header';
import MobileNav from './_mobile-nav';
import Overlay from './_overlay';
import Panels from './_panels';
import PrimaryNav from './_primary-nav';
import SearchAC from './_search-ac';

import article from './templates/_article';
import authors from './templates/_authors';
import home from './templates/_home';
import issue from './templates/_issue';
import newsFeatures from './templates/_news-features';
import subscribe from './templates/_subscribe';

const log = debug('site');
class Site {
	constructor() {
		this.mediaQueries = mediaQueries;

		document.addEventListener( 'DOMContentLoaded', () => this.ready() );
		window.addEventListener( 'load', () => this.load() );
	}

	ready() {
		this.clipboard    = new Clipboard( '[data-clipboard-text]' );
		this.fitvids      = fitvid(); // initialize fitvid videos
		this.mobileHeader = new MobileHeader( '.header' );
		this.mobileNav    = new MobileNav( '.header' );
		this.primaryNav   = new PrimaryNav('.nav--primary');
		this.overlay      = new Overlay();
		this.panels       = Array.from( document.querySelectorAll( '.panels' ) ).map( n => new Panels(n) );
		this.searchAC     = Array.from( document.querySelectorAll( '.search-form' ) ).map( ( node ) => new SearchAC( node ) );

		this.filters = Array.from( document.querySelectorAll( '.filters' ) ).map( ( form ) => {
			const filter = new Filters( form );
			filter.init();
			return filter;
		} );

		if ( document.body.classList.contains( 'page-template-authors' ) ) {
			this.authors = authors();
		}

		if ( document.body.classList.contains( 'subscribe' ) ) {
			this.subscribe = subscribe();
		}

		if ( document.body.classList.contains( 'page-template-home' ) ) {
			this.home = home();
		}

		if ( document.body.classList.contains( 'news-features' ) ) {
			this.newsFeatures = newsFeatures();
		}

		if ( document.body.classList.contains( 'single-article' ) ) {
			this.article = article();
		}

		if ( document.body.classList.contains( 'issue' ) ) {
			this.issue = issue();
		}

		log('document.DOMContentLoaded');
	}

	load() {
		// example of ES2015 modules loading & tree shaking
		emptyLinks();

		log('window.load');
	}
}

export default Site;
